import Typography from '@mui/material/Typography';
import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import useWizardJump from '@swf/core/hooks/useWizardJump';

import Prompt from '../../Prompt/Prompt';

import {
  TXTCLI_OK,
  TXTWCL_If_the_problem_persistsX_visit_ELL,
  TXTWCL_If_youXre_an_Ontario_residentX_ELL,
  TXTWCL_If_youXre_not_an_Ontario_resid_ELL,
  TXTWCL_There_has_been_an_issue_with_y_ELL,
  TXTWCL_WeXve_detected_your_location_a_ELL
} from './RestrictedState.messages.json';

interface Props {
  onClose(): void;
}

const RestrictedState: React.FC<Props> = ({ onClose }) => {
  const { jumpBack } = useWizardJump();

  return (
    <Prompt
      variant="error"
      title={{ translation: TXTWCL_There_has_been_an_issue_with_y_ELL }}
      primaryButton={{ translation: TXTCLI_OK }}
      onPrimaryButtonClick={() => jumpBack('#signup.signup-country')}
      onClose={onClose}
    >
      <Typography>
        <Translation {...TXTWCL_WeXve_detected_your_location_a_ELL} />{' '}
        <Translation {...TXTWCL_If_youXre_an_Ontario_residentX_ELL} />{' '}
        <Translation {...TXTWCL_If_youXre_not_an_Ontario_resid_ELL} />{' '}
        <Translation
          {...TXTWCL_If_the_problem_persistsX_visit_ELL}
          values={{
            a: (msg: React.ReactNode) => (
              <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
            )
          }}
        />
      </Typography>
    </Prompt>
  );
};

export default RestrictedState;
